import { WarningCircle } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

const NighttimeInfo = () => {
  const { t } = useTranslation(['eventManagement'])

  return (
    <div className="columns nighttime-info-column">
      <div className="column is-12">
        <p>{t('eventManagement:common.whenToSendReminder')}</p>
        <p className="event-form-reminder-input-nighttime-info">
          <WarningCircle />
          {t('eventManagement:common.nighttimeHoursDisabled')}
        </p>
      </div>
    </div>
  )
}

export default NighttimeInfo
